module.exports = __webpack_public_path__ + "static/media/icon_filled-section_current-done.53b29561.svg";